import { render, staticRenderFns } from "./ChooseStandardMessage.vue?vue&type=template&id=97c71e92&scoped=true&"
import script from "./ChooseStandardMessage.vue?vue&type=script&lang=ts&"
export * from "./ChooseStandardMessage.vue?vue&type=script&lang=ts&"
import style0 from "./ChooseStandardMessage.vue?vue&type=style&index=0&id=97c71e92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c71e92",
  null
  
)

export default component.exports